import fetch from '@/api/fetch';

const commonParams = {
  sysParam: {
    appKey: 1213,
    format: 'JSON',
    locale: 'zh_CN',
    sign: 'ajsdfkjdlkfgjl;kwjdfg',
  },
};

// 获取部门列表
export function getDepartList() {
  return fetch({
    url: '/baccount/workbench/dept/list',
    method: 'post',
    data: commonParams,
  });
}

// 根据部门 id 获取部门信息
export function getDepartInfoById(params) {
  return fetch({
    url: '/baccount/workbench/dept/info',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 新建部门
export function addDepartment(params) {
  return fetch({
    url: '/baccount/workbench/dept/add',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 删除部门
export function deleteDepartment(params) {
  return fetch({
    url: '/baccount/workbench/dept/delete',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}

// 更新部门信息
export function updateDepartment(params) {
  return fetch({
    url: '/baccount/workbench/dept/update',
    method: 'post',
    data: { ...commonParams, ...params },
  });
}
